import { Button, Dropdown, theme } from "antd";
import * as Icon from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "context/app";
import { useItemsScreenContext } from "pages/items";
import { CustomButtonLink } from "components/Buttons";

function ListOptionFolder({ data }) {
    const { token } = theme.useToken();
    const navigate = useNavigate();
    const { showModal } = useAppContext();
    const { currentFolder, currentFolderPath } = useItemsScreenContext();

    const iconStyle = { fontSize: 18 };
    const options = [
        {
            key: "move",
            label: <div>Move to Folder</div>,
            icon: <Icon.FolderOutlined style={{ ...iconStyle }}></Icon.FolderOutlined>,
        },

        {
            key: "create_label",
            label: <div>Create Label</div>,
            icon: <Icon.BarcodeOutlined style={{ ...iconStyle }}></Icon.BarcodeOutlined>,
        },

        {
            key: "export",
            label: <div>Export</div>,
            icon: <Icon.UploadOutlined style={{ ...iconStyle }}></Icon.UploadOutlined>,
        },

        // {
        //     key: "transaction",
        //     label: <div>Transactions</div>,
        //     icon: <Icon.AccountBookOutlined style={{ ...iconStyle }}></Icon.AccountBookOutlined>,
        // },

        {
            key: "divider",
            type: "divider", // Must have
        },

        {
            key: "clone",
            label: <div>Clone</div>,
            icon: <Icon.CopyOutlined style={{ ...iconStyle }}></Icon.CopyOutlined>,
        },
        {
            key: "edit",
            label: <div>Edit</div>,
            icon: <Icon.EditOutlined style={{ ...iconStyle }}></Icon.EditOutlined>,
        },
        {
            key: "delete",
            label: <div>Delete</div>,
            icon: <Icon.DeleteOutlined style={{ ...iconStyle }}></Icon.DeleteOutlined>,
        },
    ].filter((option) => {
        if (data?.is_root) {
            return !["move", "clone", "edit", "delete", "divider"].includes(option.key);
        }

        return true;
    });

    const folders = [{ ...data, entity_type: "folder" }];

    const menuClick = ({ item, key, keyPath, domEvent }) => {
        console.log({ item, key, keyPath });

        switch (key) {
            case "edit":
                navigate(`/folder-edit/${data.id}`);
                break;
            case "create_label":
                showModal("createLabel", {
                    items: folders,
                    folderId: currentFolder,
                });
                break;
            case "export":
                showModal("export", {
                    items: folders,
                    folderId: currentFolder,
                });
                break;
            case "move":
                showModal("moveFolders", {
                    items: folders,
                    folderId: currentFolder,
                });
                break;
            case "delete":
                showModal("delete", {
                    items: folders,
                    folderId: currentFolder,
                });
                break;
            case "clone":
                showModal("clone", {
                    items: folders,
                    folderId: currentFolder,
                });
                break;
            default:
                break;
        }
    };

    return (
        <Dropdown
            menu={{
                items: options,
                onClick: menuClick,
            }}
        >
            <Button type="link" style={{ padding: 0 }}>
                <Icon.MoreOutlined />
            </Button>
        </Dropdown>
    );
}

export default ListOptionFolder;
